import styled from "styled-components";

export const Container = styled.div`
    width: 100%;
    padding: 15px 100px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`;
 
export const Card = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: 1080px;
    height: auto;
    min-height: 230px;
    padding: 11.67px;
    background: #FFF;
    margin-bottom: 24px;
    border-radius: 8px;
`;

export const CardImage = styled.img`
    width: 158.654px;
    height: 158.654px;
    object-fit: cover;
    margin-right: 10px;
    border-radius: 4px; 
`;

export const BasicDetails = styled.div`
    border-right: 1px solid #CCCCCC;
    padding-right: 10px;
    margin-right: 10px;
    .details{
        display: grid;
        grid-template-columns: repeat(2, 1fr);
    }
`;

export const CardTitle = styled.span`
    color: #333;
    font-size: 18px;
    font-weight: 700;
    line-height: 24px;

`;

export const Price = styled.span`
    color: #333;
    font-size: 18px;
    font-weight: 700;
`;

export const IconContainer = styled.div`
    width: 26px;
    height: 26px;
    background: #F1E5F1;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const Icon = styled.img``;

export const DetailContainer = styled.div`
    font-size: 12px;
    font-weight: 400;
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 16px; 
`;

export const DetailText = styled.span``;

export const ButtonContainer = styled.div`
    display: flex;
    justify-content: space-between;
`;

export const InputButtonContainer = styled.div`
    width: auto;
    height: 32px;
`;

export const Button = styled.button`
    border-radius: 0px 4px 4px 0px;
    background: #F37021;
`;

export const Input = styled.input`
    width: 120px;
    min-height: 32px;
`;

export const ReportLink = styled.a`
    display: flex;
    width: 158.654px;
    height: 32px;
    padding: 10px;
    justify-content: center;
    align-items: center;
    gap: 8px;
    border-radius: 4px;
    background: #FFF4E2;
    color: #000;
    font-size: 14px;
    font-weight: 400;

    &:hover{
        background-color: #FAE8CA;
    }

`;

export const MoreInfo = styled.div`
        display: flex;
        gap: 24px;
`;

